import Component from '../core/Component'
import support from '../utils/BrowserSupport'
import keycode from 'keycode'
import DOMPurify from 'dompurify'
import { loadComponents, removeComponents } from '../core/componentUtils'
import { enableScrolling, disableScrolling } from '../services/Scroll'

export const STATES = {
    ACTIVE: 'is-active',
    VISIBLE: 'is-visible',
}

export default class Sidebar extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            background: null,
            close: null,
            content: null,
            link: null,
        }

        this.handleKeyDown = this.handleKeyDown
    }

    prepare() {
        this.ref.close.addEventListener('click', this.handleCloseClick)
        this.ref.background.addEventListener('click', this.handleCloseClick)
        this.element.addEventListener('click', this.handleInnerClick)

        this.element.addEventListener(support.transitionEnd, () => {
            if (!this.is(STATES.ACTIVE)) {
                this.element.classList.remove(STATES.VISIBLE)
            }
        })
    }

    handleCloseClick = (event) => {
        event.preventDefault()
        this.close()
    }

    handleInnerClick = (event) => {
        if (event.target.closest('[data-ref="link"]')) {
            this.close()
        }
    }

    handleKeyDown = (event) => {
        if (keycode(event.keyCode) === 'esc') {
            this.close()
        }
    }

    open() {
        disableScrolling()
        this.element.classList.add(STATES.VISIBLE)
        this.element.offsetWidth
        this.element.classList.add(STATES.ACTIVE)
        this.ref.content.scrollTop = 0
        document.addEventListener('keydown', this.handleKeyDown)
        this.emit('open')
    }

    close() {
        this.element.classList.remove(STATES.ACTIVE)
        document.removeEventListener('keydown', this.handleKeyDown)
        enableScrolling()
        this.emit('close')
    }

    setContent(html) {
        removeComponents(this.ref.content)
        this.ref.content.innerHTML = DOMPurify.sanitize(html)
        this.ref.content.scrollTop = 0
        loadComponents(this.ref.content)

        return this
    }
}
